import { ReactNode } from "react";
import clsx from "clsx";

type Props = {
  isCart: boolean;
  headerBg: boolean;
  children: ReactNode;
};

export default function ShopContentWrapper({ isCart, headerBg, children }: Props) {
  return (
    <div
      className={clsx(
        "relative flex flex-1 min-h-0 pb-7.5",
        headerBg ? "max-h-[43.875rem]" : "max-h-[46.875rem]",
      )}
    >
      <span
        className={clsx(
          "absolute z-2 right-7.5 w-[54.45rem] h-11 bg-gradient-to-t from-dark-900 to-transparent pointer-events-none",
          isCart ? "bottom-[9.5rem]" : "bottom-7.5",
        )}
      />
      {children}
    </div>
  );
}
